module.exports = __webpack_public_path__ + "img/editJournal.c3fec75d.png";